const tr = {
  infobipAccess: {
    attributes: {
      api_token: 'Token da API Infobip',
      sender: 'Número remetente (WhatsApp da Infobip)',
    },
    extras: {
      title: 'Acesso à Infobip',
      senderHelp: 'Ex.: 554941011000',
      tokenConfigured: 'Token configurado',
      tokenMissing: 'Token do ambiente (INFOBIP_API_KEY)',
      tokenNone: 'Sem token',
      removeToken: 'Remover token',
      removeTokenConfirm: 'Remover o token da Infobip? Sem token aqui nem no ambiente, nenhuma mensagem sai.',
      tokenRemoved: 'Token removido.',
      saveTitle: 'Salvar acesso à Infobip',
      saveConfirm: 'Salvar o acesso usado pelas duas campanhas e pela confirmação de agendamento?',
      saved: 'Configuração salva.',
      confirm: 'Confirmar',
    },
  },
};

export default tr;
